<template>
  <div class="fancy-heading">
    <h2 class="fancy-heading__title"><slot name="title"></slot></h2>
    <p
      v-if="$slots.description !== undefined"
      class="fancy-heading__description"
    >
      <slot name="description"></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'FancyHeading',
  components: {
  },
  data: function () {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
/**
 * Fancy Heading
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Fancy heading for non-plain content pages
 * @since 2022-06-29
**/

$component: 'fancy-heading';

.#{$component} {
  color: inherit;

  &__title {
    @include font-size(map-get($lp, 'font-size-xxl'));
    font-family: $font-family-serif;
    font-weight: $font-weight-normal;
    // text-shadow: 1px 1px 0 red;
    background: linear-gradient(to right, var(--from) 15%, var(--to) 90%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(1px 1px 0 var(--shadow));

    b {
      font-weight: 600;
    }
  }

  &__description {
    // width: 60%;
    @include margin(map-get($spacers, 4) auto);
    @include font-size(map-get($lp, 'font-size-lg'));
    font-weight: $font-weight-light;
    text-shadow: 1px 1px 0 var(--shadow);
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-xs')) {

  }
}
</style>
